import ankerIcon from "../../../../../assets/anker_icon.png";

type AnchorTextItem = {
  key: string | number;
  href: string;
  label: string;
};

/**
 * アンカーテキストリスト（アイコン＋アンカーテキストの縦積み、カルーセルなし）
 * display_link / campaign_textのリンク行 / cta_dataフォールバックリンクで共通利用
 */
export default function AnchorTextList({
  items,
  marginTop = "20px",
}: {
  items: AnchorTextItem[];
  marginTop?: string;
}) {
  if (items.length === 0) return null;
  return (
    <div style={{ marginTop, display: "flex", flexDirection: "column", gap: "8px" }}>
      {items.map((item) => (
        <a
          key={item.key}
          href={item.href}
          {...(/^(tel:|mailto:|sms:)/i.test(item.href) ? {} : { target: "_blank", rel: "noopener noreferrer" })}
          style={{
            alignSelf: "flex-start",
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 16px",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: 1.5,
            whiteSpace: "nowrap",
            borderRadius: "20px",
            backgroundColor: "#fff",
            color: "#4a90e2",
            border: "none",
            cursor: "pointer",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
            transition: "background-color 0.2s ease-in-out",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#f5f5f5";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#fff";
          }}
        >
          <img src={ankerIcon} alt="" width={20} height={20} style={{ flexShrink: 0, objectFit: "contain" }} />
          <span>{item.label}</span>
        </a>
      ))}
    </div>
  );
}
